import { render, staticRenderFns } from "./AppTabs.vue?vue&type=template&id=a1431296&"
import script from "./AppTabs.vue?vue&type=script&lang=js&"
export * from "./AppTabs.vue?vue&type=script&lang=js&"
import style0 from "./AppTabs.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports